import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import {
  deleteLender,
  getAllLenders,
  getSingleLender,
  toggleLenderActivation
} from "./queries";

const lendersApi = createApi({
  reducerPath: "lendersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    // get all users
    getAllLenders: builder.query({
      providesTags: ["all_lenders"],
      query: getAllLenders,
    }),

    // get single user
    getSingleLender: builder.query({
      providesTags: ["lender"],
      query: getSingleLender,
    }),

    // toggle user account activation
    toggleLenderActivation: builder.mutation({
      invalidatesTags: ["all_lenders"],
      query: toggleLenderActivation,
    }),

    // delete user account
    deleteLender: builder.mutation({
      invalidatesTags: ["all_lenders"],
      query: deleteLender,
    }),
  }),
});

export const {
  useGetAllLendersQuery,
  useGetSingleLenderQuery,
  useToggleLenderActivationMutation,
  useDeleteLenderMutation,
  reducer: lendersApiReducer,
  reducerPath: lendersApiReducerPath,
  middleware: lendersApiMiddleWare,
} = lendersApi;
